import React from "react";
import { Waves, Music2, Dog, Sun, Wifi, Baby, Utensils, Beer, Sparkles, Award, Ship, Flag, Fish, Mountain, UserCheck } from "lucide-react";

const MAP = {
  pool: { Icon: Waves, label: "Pool" },
  entertainment: { Icon: Music2, label: "Entertainment" },
  dog_friendly: { Icon: Dog, label: "Dog friendly" },
  beach: { Icon: Sun, label: "Beach" },
  wifi: { Icon: Wifi, label: "WiFi" },
  kids_club: { Icon: Baby, label: "Kids club" },
  restaurant: { Icon: Utensils, label: "Restaurant" },
  bar: { Icon: Beer, label: "Bar" },
  spa: { Icon: Sparkles, label: "Spa" },
  surfing: { Icon: Award, label: "Surfing" },
  watersports: { Icon: Ship, label: "Watersports" },
  golf: { Icon: Flag, label: "Golf" },
  fishing: { Icon: Fish, label: "Fishing" },
  horse_riding: { Icon: Mountain, label: "Horse riding" },
  adults_only: { Icon: UserCheck, label: "Adults only" },
};

export default function FacilityIcon({ name, withLabel = false, className = "" }) {
  const entry = MAP[name] || { Icon: Sparkles, label: name };
  const Icon = entry.Icon;
  return (
    <span
      className={`inline-flex items-center gap-1.5 text-ink/70 ${className}`}
      title={entry.label}
      data-testid={`facility-${name}`}
    >
      <Icon className="w-4 h-4" />
      {withLabel && <span className="text-xs">{entry.label}</span>}
    </span>
  );
}
